<template>
  <v-navigation-drawer
    v-model="panel.visible"
    v-click-outside="clickedOutside"
    fixed
    right
    stateless
    temporary
    disable-resize-watcher
    width="1024"
    @input="panelInputChanged"
  >
    <v-container>
      <LessonsEditManager
        v-if="items"
        :items="items"
        :lesson="lesson"
        :definition="definition"
        :has-any-test="hasAnyTest"
        @update="updateItems"
        @slidesChanged="slidesChanged"
        @disableOutsideClick="disableOutsideClick"
        @enableOutsideClick="enableOutsideClick"
      >
        <template v-slot:manageButtons>
          <v-row class="mt-4">
            <v-col>
              <v-btn class="action-btn" color="success" block :loading="loading" @click="submit">Zapisz zmiany</v-btn>
            </v-col>
            <v-col>
              <v-dialog v-model="dialog" persistent max-width="400">
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="action-btn"
                    color="error"
                    block
                    :disabled="loading"
                    v-on="formChanged ? on : { click: cancel }"
                    >Anuluj</v-btn
                  >
                </template>
                <v-card>
                  <v-toolbar color="error" dark flat>
                    <v-toolbar-title>Ostrzeżenie</v-toolbar-title>
                  </v-toolbar>
                  <v-card-text class="mt-4">Czy na pewno chcesz anulować wprowadzone zmiany?</v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="text--secondary" text @click="cancelWarning">Nie</v-btn>
                    <v-btn color="error" text @click="cancel">Tak</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
        </template>
      </LessonsEditManager>
      <v-skeleton-loader v-else type="image, table-tfoot" />
    </v-container>
  </v-navigation-drawer>
</template>

<script>
import LessonsEditManager from '@/components/manage/courses/right-panel/lesson-edit/LessonsEditManager.vue';
import ClickOutside from 'vue-click-outside';
import { createNamespacedHelpers } from 'vuex';

const { mapState, mapActions } = createNamespacedHelpers('courses');

export default {
  directives: {
    ClickOutside
  },
  components: {
    LessonsEditManager
  },
  data: function() {
    return {
      dialog: false,
      items: null,
      lessonName: null,
      newLesson: {},
      loading: false,
      formValid: false,
      formChanged: false,
      panel: {
        visible: true,
        firstLoad: false,
        outsideEnabled: true
      }
    };
  },
  computed: {
    ...mapState({
      lesson: state => state.activeCourseEditTree.activeElement.element,
      courseId: state => state.activeCourseEditTree.course.id,
      definition: state => state.activeCourseEditTree.activeElement.definition
    }),
    hasAnyTest() {
      for (const i in this.newLesson.screens) {
        if (
          Object.prototype.hasOwnProperty.call(this.newLesson.screens, i) &&
          this.newLesson.screens[i].type === 'TestScreen'
        ) {
          return true;
        }
      }

      return false;
    }
  },
  async mounted() {
    this.lessonName = this.lesson.name;
    this.formValid = true;
    if (!this.lesson.newDefinition) {
      if (this.lesson.id === -1) {
        this.items = [];
        return;
      }

      await this.requestElementDefinition({ id: this.lesson.id });
      this.items = this.definition.screens ? JSON.parse(JSON.stringify(this.definition.screens)) : [];
      this.newLesson = {
        name: this.lesson.name,
        displayType: this.definition.displayType,
        passLevel: this.definition.passLevel,
        screens: this.items
      };
    } else {
      this.items = JSON.parse(JSON.stringify(this.lesson.newDefinition.screens));
      this.newLesson = {
        name: this.lesson.name,
        displayType: this.lesson.newDefinition.displayType,
        passLevel: this.lesson.newDefinition.passLevel,
        screens: this.items
      };
    }
  },
  methods: {
    ...mapActions(['saveLesson', 'resetActiveElement', 'requestElementDefinition']),
    async submit() {
      if (this.formValid) {
        this.loading = true;
        await this.saveLesson({
          courseId: this.courseId,
          instance: this.lesson,
          name: this.newLesson.name,
          isRequired: this.hasAnyTest ? true : this.newLesson.isRequired,
          definition: this.definition,
          newDefinition: {
            passLevel: this.hasAnyTest
              ? !this.newLesson.passLevel && this.newLesson.passLevel !== 0
                ? 100
                : this.newLesson.passLevel
              : null,
            displayType: this.newLesson.displayType,
            screens: this.newLesson.screens
          }
        });
        this.loading = false;
      }
    },
    cancel() {
      this.dialog = false;
      this.resetActiveElement();
    },
    updateItems(ev) {
      this.formValid = ev.valid;
      if (ev.valid) {
        this.formChanged = true;
        this.panel.firstLoad = false;
        this.newLesson = {
          name: ev.name,
          isRequired: ev.isRequired,
          displayType: ev.displayType,
          passLevel: ev.passLevel,
          screens: ev.items
        };
        this.items = ev.items;
      }
    },
    slidesChanged() {
      this.formChanged = true;
    },
    disableOutsideClick() {
      this.panel.outsideEnabled = false;
    },
    enableOutsideClick(ev) {
      this.panel.firstLoad = !(!ev || !ev.ignoreClick);
      this.panel.outsideEnabled = true;
    },
    clickedOutside() {
      if (this.panel.outsideEnabled) {
        if (this.panel.firstLoad) {
          if (this.formChanged) {
            this.dialog = true;
          } else {
            this.cancel();
          }
        }

        this.panel.firstLoad = true;
      }
    },
    panelInputChanged() {
      this.panel.firstLoad = false;
    },
    cancelWarning() {
      this.panel.firstLoad = false;
      this.dialog = false;
    }
  }
};
</script>
